// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.FuzzyVRM .ag-full-width-row .ag-cell-wrapper.ag-row-group,
.FuzzyVRM .ag-header-cell,
.ag-header-group-cell {
  padding-left: 16px;
}

.FuzzyVRM .gridPageSize {
  padding-left: 0px;
}

.EventTabPage .FuzzyVRM .ag-cell {
  padding-left: 15px;
}

.EventTabPage .FuzzyVRM {
  height: 100%;
}

.FuzzyVRM .aggridbasecomponent {
  /* height: 53vh; */
  /* height: 90%; */
  height: 100%;
}

.FuzzyVRM {
  display: grid;
  grid-template-rows: auto auto 1fr;
  height: inherit;
  gap: 1vh;
  /* height: 90%; */
  padding: 30px;
}

.EventTabPage .FuzzyVRM .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {
  border-left: none;
}

.EventTabPage .FuzzyVRM .attachmentIcon {
  cursor: default;
}

.FuzzyVRM .headerSection {
  display: grid;
  grid-template-rows: auto auto;
  row-gap: 1.7vh;
}

.FuzzyVRM .headerSection .divEvent {
  font-family: var(--default-FontName);
  font-size: var(--sub-header-FontSize);
  font-weight: var(--header-FontWeight);
  color: var(--default-FontColour);
  font-size: 24px;
  line-height: 32px;
  margin: 0px;
  display: flex;
  align-items: center;
}

.FuzzyVRM .gridPageSizeHeader .gridRefreshDiv {
  margin: 0px;
}

@media (min-width: 1025px) and (max-width: 1360px) {
  .FuzzyVRM {
    gap: 0px;
  }
}

.fuzzyVRM__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.7vh;
}
.fuzzyVRM__header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.fuzzyVRM__back-icon {
  cursor: pointer;
}
.fuzzyVRM__title {
  margin: 0;
  font-size: var(--sub-header-FontSize);
  font-weight: var(--header-FontWeight);
  color: var(--countValueFontColor);
}
.generateBatchBtn {
  border: none;
  background: none;
  color: #1f3c88;
  cursor: pointer;
  padding: 0;
  font-weight: 600;
}
.fuzzyVRM-viewImages-dialog__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fuzzyVRM-viewImages-dialog__close-icon {
  cursor: pointer;
}
.fuzzyVRM-viewImages-dialog .MuiDialog-paper {
  width: 80% !important;
  max-width: 900px !important;
  height: 80% !important;
  max-height: 600px !important;
  gap: 12px;
}
.fuzzyVRM-viewImages-dialog .image-timestamp {
  font-weight: 400;
  font-size: 14px;
}
.fuzzyVRM-viewImages-dialog .image-name {
  font-size: 16px;
  font-weight: var(--header-FontWeight);
}
.fuzzyVRM-viewImages-dialog .image-viewer-wrapper {
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/features/fuzzyVRM/FuzzyVRM.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,SAAS;AACX","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.FuzzyVRM .ag-full-width-row .ag-cell-wrapper.ag-row-group,\n.FuzzyVRM .ag-header-cell,\n.ag-header-group-cell {\n  padding-left: 16px;\n}\n\n.FuzzyVRM .gridPageSize {\n  padding-left: 0px;\n}\n\n.EventTabPage .FuzzyVRM .ag-cell {\n  padding-left: 15px;\n}\n\n.EventTabPage .FuzzyVRM {\n  height: 100%;\n}\n\n.FuzzyVRM .aggridbasecomponent {\n  /* height: 53vh; */\n  /* height: 90%; */\n  height: 100%;\n}\n\n.FuzzyVRM {\n  display: grid;\n  grid-template-rows: auto auto 1fr;\n  height: inherit;\n  gap: 1vh;\n  /* height: 90%; */\n  padding: 30px;\n}\n\n.EventTabPage .FuzzyVRM .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {\n  border-left: none;\n}\n\n.EventTabPage .FuzzyVRM .attachmentIcon {\n  cursor: default;\n}\n\n.FuzzyVRM .headerSection {\n  display: grid;\n  grid-template-rows: auto auto;\n  row-gap: 1.7vh;\n}\n\n.FuzzyVRM .headerSection .divEvent {\n  font-family: var(--default-FontName);\n  font-size: var(--sub-header-FontSize);\n  font-weight: var(--header-FontWeight);\n  color: var(--default-FontColour);\n  font-size: 24px;\n  line-height: 32px;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n}\n\n.FuzzyVRM .gridPageSizeHeader .gridRefreshDiv {\n  margin: 0px;\n}\n\n@media (min-width: 1025px) and (max-width: 1360px) {\n  .FuzzyVRM {\n    gap: 0px;\n  }\n}\n\n.fuzzyVRM__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.7vh;\n}\n.fuzzyVRM__header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.fuzzyVRM__back-icon {\n  cursor: pointer;\n}\n.fuzzyVRM__title {\n  margin: 0;\n  font-size: var(--sub-header-FontSize);\n  font-weight: var(--header-FontWeight);\n  color: var(--countValueFontColor);\n}\n.generateBatchBtn {\n  border: none;\n  background: none;\n  color: #1f3c88;\n  cursor: pointer;\n  padding: 0;\n  font-weight: 600;\n}\n.fuzzyVRM-viewImages-dialog__title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fuzzyVRM-viewImages-dialog__close-icon {\n  cursor: pointer;\n}\n.fuzzyVRM-viewImages-dialog .MuiDialog-paper {\n  width: 80% !important;\n  max-width: 900px !important;\n  height: 80% !important;\n  max-height: 600px !important;\n  gap: 12px;\n}\n.fuzzyVRM-viewImages-dialog .image-timestamp {\n  font-weight: 400;\n  font-size: 14px;\n}\n.fuzzyVRM-viewImages-dialog .image-name {\n  font-size: 16px;\n  font-weight: var(--header-FontWeight);\n}\n.fuzzyVRM-viewImages-dialog .image-viewer-wrapper {\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
